// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__12cK6","disabled":"FileBtn_disabled__2u20T","warn":"FileBtn_warn__14CIq","fade":"FileBtn_fade__2PBoT"};